module.exports = __webpack_public_path__ + "qr3.4e0fa99f.png";